import React from "react";
import BaseElement from "components/FormElements/BaseElement";

export default function LowTextInput(props) {
    const defaultProps = {
        label: "Text Input",
        id: "text-input",
        name: "text-input",
        type: "text",
        autoComplete: "off",
        value: "",
        isError: false,
        errorText: "",
        variant: false,
        onChange: () => {},
    };
    const useProps = Object.assign(defaultProps, {}, props);

    const label = (
        <label
            htmlFor={useProps.id}
            className="block text-sm font-medium text-gray-700"
        >
            {props.label}
        </label>
    );

    const input = (
        <input
            {...useProps}
            value={useProps.value || ""}
            className="block w-full rounded-md border-gray-300 py-2 px-4 shadow-sm focus:border-green-500 focus:ring-green-500 disabled:bg-white sm:text-sm"
        />
    );

    const helperText = useProps.helpertext ? (
        <p className="mt-1.5 text-xs text-gray-500">{useProps.helpertext}</p>
    ) : (
        ""
    );

    return (
        <BaseElement
            {...useProps}
            label={label}
            input={input}
            helpertext={helperText}
        />
    );
}
